import { makeEntitySubscriptionContext } from 'requests/resources/makeEntitySubscriptionContext';

const [UserSubscriptionProvider, useUserSubscripton] = makeEntitySubscriptionContext('users', [
  'luma:server:user:update',
]);

export { UserSubscriptionProvider, useUserSubscripton };
